import { render, staticRenderFns } from "./AiRequestsProductCard.vue?vue&type=template&id=27a5d9cd&scoped=true"
import script from "./AiRequestsProductCard.vue?vue&type=script&lang=js"
export * from "./AiRequestsProductCard.vue?vue&type=script&lang=js"
import style0 from "./AiRequestsProductCard.vue?vue&type=style&index=0&id=27a5d9cd&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27a5d9cd",
  null
  
)

export default component.exports